var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 122.5C11.7639 122.5 10.5 121.771 9.625 120.313C8.75 118.854 8.75 117.396 9.625 115.938L66.2083 18.2292C67.0833 16.7709 68.3472 16.0417 70 16.0417C71.6528 16.0417 72.9167 16.7709 73.7917 18.2292L130.375 115.938C131.25 117.396 131.25 118.854 130.375 120.313C129.5 121.771 128.236 122.5 126.583 122.5H13.4167ZM70.5833 56.5834C69.3194 56.5834 68.2743 56.9966 67.4479 57.823C66.6215 58.6494 66.2083 59.6945 66.2083 60.9584V84.8751C66.2083 86.139 66.6215 87.1841 67.4479 88.0105C68.2743 88.8369 69.3194 89.2501 70.5833 89.2501C71.8472 89.2501 72.8924 88.8369 73.7188 88.0105C74.5451 87.1841 74.9583 86.139 74.9583 84.8751V60.9584C74.9583 59.6945 74.5451 58.6494 73.7188 57.823C72.8924 56.9966 71.8472 56.5834 70.5833 56.5834ZM70.5833 105.438C71.8472 105.438 72.8924 105.024 73.7188 104.198C74.5451 103.372 74.9583 102.326 74.9583 101.063C74.9583 99.7987 74.5451 98.7536 73.7188 97.9272C72.8924 97.1008 71.8472 96.6876 70.5833 96.6876C69.3194 96.6876 68.2743 97.1008 67.4479 97.9272C66.6215 98.7536 66.2083 99.7987 66.2083 101.063C66.2083 102.326 66.6215 103.372 67.4479 104.198C68.2743 105.024 69.3194 105.438 70.5833 105.438ZM21 113.75H119L70 29.1667L21 113.75Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.be97a72945d0a7da0998a8b079bccde1.svg";
export { ForwardRef as ReactComponent };